(function () {
  var scriptVersion = '2';
  if (window.DearmoraSizeChartModalVersion === scriptVersion) return;
  window.DearmoraSizeChartModal = true;
  window.DearmoraSizeChartModalVersion = scriptVersion;

  var openSelector = '[data-size-chart-open]';
  var closeSelector = '[data-size-chart-close]';
  var unitSelector = '[data-size-chart-unit]';
  var lastFocusedElement = null;
  var closeTimers = new WeakMap();

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
    });
  }

  function findModal(modalId, trigger) {
    var candidates = Array.prototype.slice.call(document.querySelectorAll('.product-size-chart-modal')).filter(
      function (modal) {
        return modal.id === modalId;
      }
    );
    var productInfo = trigger && trigger.closest ? trigger.closest('product-info') : null;
    var scopedModal = productInfo
      ? candidates.find(function (modal) {
          return productInfo.contains(modal);
        })
      : null;

    return scopedModal || candidates[0] || document.getElementById(modalId);
  }

  function setImportantStyle(element, property, value) {
    if (!element) return;
    element.style.setProperty(property, value, 'important');
  }

  function forceViewportLayout(modal) {
    var overlay = modal.querySelector('.product-size-chart-modal__overlay');
    var dialog = modal.querySelector('.product-size-chart-modal__dialog');

    setImportantStyle(modal, 'position', 'fixed');
    setImportantStyle(modal, 'inset', '0');
    setImportantStyle(modal, 'z-index', '2147483000');
    setImportantStyle(modal, 'display', 'grid');
    setImportantStyle(modal, 'place-items', 'center');
    setImportantStyle(modal, 'width', '100vw');
    setImportantStyle(modal, 'min-height', '100vh');
    setImportantStyle(modal, 'margin', '0');
    setImportantStyle(modal, 'padding', 'clamp(1.6rem, 3vw, 3.2rem)');
    setImportantStyle(modal, 'background', 'rgba(0, 0, 0, 0.58)');
    setImportantStyle(modal, 'isolation', 'isolate');

    setImportantStyle(overlay, 'position', 'absolute');
    setImportantStyle(overlay, 'inset', '0');
    setImportantStyle(overlay, 'z-index', '0');
    setImportantStyle(overlay, 'background', 'rgba(36, 36, 36, 0.64)');
    setImportantStyle(overlay, '-webkit-backdrop-filter', 'blur(8px) saturate(105%)');
    setImportantStyle(overlay, 'backdrop-filter', 'blur(8px) saturate(105%)');

    setImportantStyle(dialog, 'position', 'relative');
    setImportantStyle(dialog, 'z-index', '1');
    setImportantStyle(dialog, 'width', 'min(88rem, calc(100vw - 4rem))');
    setImportantStyle(dialog, 'max-height', 'calc(100vh - 7.2rem)');
  }

  function prepareModal(modal) {
    Array.prototype.slice.call(document.querySelectorAll('.product-size-chart-modal')).forEach(function (candidate) {
      if (candidate !== modal && candidate.id === modal.id && candidate.parentElement === document.body) {
        candidate.remove();
      }
    });

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    forceViewportLayout(modal);
  }

  function openModal(modalId, trigger) {
    var modal = findModal(modalId, trigger);
    if (!modal) return;

    var closeTimer = closeTimers.get(modal);
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimers.delete(modal);
    }

    prepareModal(modal);
    lastFocusedElement = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-chart-modal-open');
    syncUnit(modal, 'cm');

    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');

      window.requestAnimationFrame(function () {
        var closeButton = modal.querySelector(closeSelector);
        var dialog = modal.querySelector('.product-size-chart-modal__dialog');
        (closeButton || dialog || modal).focus();
      });
    });
  }

  function closeModal(modal) {
    if (!modal) return;

    var existingCloseTimer = closeTimers.get(modal);
    if (existingCloseTimer) {
      window.clearTimeout(existingCloseTimer);
      closeTimers.delete(modal);
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    var closeDelay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280;
    var closeTimer = window.setTimeout(function () {
      modal.hidden = true;
      closeTimers.delete(modal);

      if (!document.querySelector('.product-size-chart-modal.is-open')) {
        document.body.classList.remove('size-chart-modal-open');
      }

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }, closeDelay);

    closeTimers.set(modal, closeTimer);
  }

  function syncUnit(modal, unit) {
    modal.querySelectorAll(unitSelector).forEach(function (button) {
      var isActive = button.dataset.sizeChartUnit === unit;
      button.classList.toggle('kiwi-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    modal.querySelectorAll('[data-size-unit-cm][data-size-unit-in]').forEach(function (cell) {
      var nextValue = unit === 'in' ? cell.dataset.sizeUnitIn : cell.dataset.sizeUnitCm;
      if (nextValue) cell.textContent = nextValue;
    });
  }

  function trapTabKey(event, modal) {
    if (event.key !== 'Tab') return;

    var focusableElements = getFocusableElements(modal);
    if (!focusableElements.length) {
      event.preventDefault();
      var dialog = modal.querySelector('.product-size-chart-modal__dialog');
      if (dialog) dialog.focus();
      return;
    }

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var unitButton = event.target.closest(unitSelector);
    if (unitButton) {
      var unitModal = unitButton.closest('.product-size-chart-modal');
      if (!unitModal) return;

      event.preventDefault();
      syncUnit(unitModal, unitButton.dataset.sizeChartUnit);
      return;
    }

    var openButton = event.target.closest(openSelector);
    if (openButton) {
      event.preventDefault();
      openModal(openButton.dataset.sizeChartOpen, openButton);
      return;
    }

    var closeButton = event.target.closest(closeSelector);
    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('.product-size-chart-modal'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('.product-size-chart-modal.is-open');
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    trapTabKey(event, modal);
  });
})();
